import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Typography,
  Button,
  Modal,
  Checkbox,
  Input,
  Icon,
} from '@safedns/skydns-ui-react-lib';

import { notificationSuccess } from '../../store/notificationReducer';

import styles from './AuthKeyCreatedDialog.module.scss';

import sprite from '../../icons/sprite.svg';

function createHiddenAuthKey(key) {
  const lastSymbolsToShow = key.slice(key.length - 4);

  return '.......' + lastSymbolsToShow;
}

function createNotification(message) {
  return {
    isNotification: true,
    type: 'success',
    message,
  };
}

const AuthKeyCreatedDialog = ({ authKey, onDialogAction }) => {
  const dispatch = useDispatch();

  const [isChecked, setCheckboxState] = useState(false);
  const [authKeys, setAuthKeys] = useState({
    default: '',
    base64: '',
  });

  // If we don't use useEffect, there can be a bug with empty auth key
  useEffect(() => {
    setAuthKeys({
      default: authKey,
    });
  }, [authKey]);

  const createTxtFileHandler = () => {
    const defaultKey = `AuthKey: ${authKeys.default}`;

    const blob = new Blob([defaultKey], {
      type: 'text/plain',
    });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');

    a.href = url;
    a.download = 'authKey.txt';
    a.style.display = 'none';

    document.body.appendChild(a);

    dispatch(notificationSuccess(createNotification('Сохранен')));

    a.click();

    // Clean the blob object and the anchor
    URL.revokeObjectURL(url);
    document.body.removeChild(a);
  };

  const checkboxStateHandler = () => {
    setCheckboxState((prevState) => !prevState);
  };

  const copyToClipboard = (_e) => {
    navigator.clipboard.writeText(authKeys.default);

    dispatch(
      notificationSuccess(createNotification('Ключ скопирован в буфер обмена'))
    );
  };

  return (
    <Modal
      isOpen={true}
      title="Новый AuthKey сгенерирован"
      sx={{ maxWidth: 460 }}
      onClose={onDialogAction}
    >
      <div className={styles['dialog-content']}>
        <div className={styles['warning-box']}>
          <Icon
            id="info"
            sprite={sprite}
            width={16}
            height={16}
            className={styles['warning-icon']}
          />
          <Typography className={styles['warning-text']}>
            Скопируйте и сохраните этот ключ в надежном месте — он отображается
            только один раз
          </Typography>
        </div>
        <div className={styles['input-wrapper']}>
          <Input
            id="auth-key"
            label="AuthKey"
            value={createHiddenAuthKey(authKeys.default)}
            isDisabled
            size="small"
            sx={{ textIndent: 8 }}
            endAdornment={
              <Button isIconButton variant="icon" onClick={copyToClipboard}>
                <Icon
                  id="copy"
                  sprite={sprite}
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                />
              </Button>
            }
          />
        </div>

        <Checkbox
          id="save-control"
          label={<Typography variant="body2">Я сохранил(а) ключ</Typography>}
          checked={isChecked}
          onChange={checkboxStateHandler}
          className={styles['checkbox-wrapper']}
        />
        <div className={styles['button-grid']}>
          <Button
            variant="secondary"
            size="small"
            onClick={createTxtFileHandler}
            className={styles['button-cancel']}
          >
            Сохранить .txt
          </Button>
          <Button
            variant="primary"
            size="small"
            onClick={onDialogAction}
            isDisabled={!isChecked}
            className={styles['button-submit']}
          >
            Готово
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AuthKeyCreatedDialog;
